import API from '../Services/API';
import { useSession } from '../Components/Session';
import Model from './Model';

const useGrants = () => {
    return Model({
        stateKey: ['users', 'grants'],
        // alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get('/users/grants'),
        returnDataKey: 'grants',
        defaultLoadingError: 'Sorry, there was an error loading your other accounts.',
    })
}

const useUser = (alwaysRefresh) => {
    const {refresh} = useSession();

    return Model({
        stateKey: 'user',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get('/user'),
        returnDataKey: 'user',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user', data).then(refresh),
                        null,
                        true,
                    );
                },
                changePassword: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/changePassword', data),
                        null,
                        true,
                    );
                },
                changeEmail: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/changeEmail', data),
                        null,
                        true,
                    );
                },
                closeAccount: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/closeAccount', data),
                        null,
                        true,
                    );
                },
                resetAccount: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/resetAccount', data),
                        null,
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading your account.',
    })
}

const useAuthDevices = (alwaysRefresh) => {
    return Model({
        stateKey: ['users', 'authDevices'],
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get('/authDevices'),
        returnDataKey: 'authDevices',
        registerAdditionalMethods: (opts) => {
            return {
                deleteAuthDevice: (authDeviceId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/authDevices/${authDeviceId}`),
                        null,
                        true,
                    );
                },
                setupSoftwareMfa: () => {
                    return API.post('/authDevices/softwareMfa/setup');
                },
                confirmSoftwareMfa: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/authDevices/softwareMfa/confirm', data),
                        null,
                        true,
                    );
                },
                setupRecoveryCode: () => {
                    return API.post('/authDevices/recoveryCode/setup');
                },
                confirmRecoveryCode: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/authDevices/recoveryCode/confirm', data),
                        null,
                        true,
                    );
                },
                setupPasskey: () => {
                    return API.post('/authDevices/passkey/setup');
                },
                confirmPasskey: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/authDevices/passkey/confirm', data),
                        null,
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading your authentication devices.',
    })
}

const AuthDeviceTypes = {
    TRUSTED_DEVICE: 'TrustedDevice',
    SOFTWARE_MFA: 'SoftwareMfa',
    PASSKEY: 'Passkey',
    RECOVERY_CODE: 'RecoveryCode',
}

const ChallengeTypes = {
    EMAIL: 'email',
    PASSWORD: 'password',
    TRUST_DEVICE: 'trustDevice',
    MFA: 'mfa',
    PASSKEY: 'passkey',
}

const hasRole = (role) => {
    return API.isRoleSufficient(role);
}

const Roles = {
    Owner: 'Owner',
    Manager: 'Manager',
    Worker: 'Worker',
    LimitedWorker: 'Limited Worker',
}

export {
    useUser,
    useGrants,
    useAuthDevices,
    AuthDeviceTypes,
    ChallengeTypes,
    hasRole,
    Roles,
}
